import { XIcon } from "lucide-react";

// NOTE: USED IN EDIT PRODUCT BOTTOM SHEET - DISPLAYS PREVIEW OF IMAGES


interface ProductImagePreviewCardProps {
    image: string;
    showClose?: boolean;
    onClose?: () => void;
    title?: string;
    className?: string;
    onClick?: () => void;
    index?: string;
}

export const ProductImagePreviewCard = ({
    image,
    showClose,
    onClose,
    title,
    className,
    onClick,
    index,
}: Readonly<ProductImagePreviewCardProps>) => {
    return (
        <div
            onClick={onClick}
            className={`${className} relative rounded-2xl cursor-pointer overflow-hidden bg-gray-100`}
        >
            <div className="relative bg-gray-200 w-full overflow-hidden rounded-2xl">
                <img
                    src={image} // Use the single 'image' prop
                    alt={title ?? `Product Image ${index ?? ''}`.trim()} // Improved alt text
                    className={`w-full h-auto object-cover object-bottom`}
                // referrerPolicy="no-referrer"
                />
            </div>
            {/* Removed Badge section as it's not relevant for simple image preview */}
            {index && (
                <p className="bg-black rounded-[6px] mt-1 ml-1 font-semibold py-[3px] px-[7px] text-white text-xs absolute top-1 left-1">
                    {index}
                </p>
            )}
            {/* Removed title overlay as it's not needed for image preview */}
            {showClose && (
                <button
                    onClick={(e) => {
                        e.stopPropagation(); // Prevent triggering onClick of the div
                        onClose?.();
                    }}
                    className="absolute cursor-pointer top-2 right-2 bg-black bg-opacity-50 rounded-full p-0.5"
                >
                    <XIcon stroke="white" width={16} height={16} /> {/* Adjusted size */}
                </button>
            )}
        </div>
    );
}; 